import { render } from "./AdultsSectionFour.vue?vue&type=template&id=d171f54e&scoped=true"
import script from "./AdultsSectionFour.vue?vue&type=script&lang=js"
export * from "./AdultsSectionFour.vue?vue&type=script&lang=js"

import "./AdultsSectionFour.vue?vue&type=style&index=0&id=d171f54e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d171f54e"]])

export default __exports__